module.exports = __webpack_public_path__ + "img/copyright.1b84bbdc.png";